import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import { renderSelectField, renderTextField } from '../../../utils/materialUiReduxForms';

import MenuItem from 'material-ui/MenuItem'

class TranslationFields extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isDialogVisible: false
    };
  }

  renderItems = (items = []) => {
   return items.map((item, i) => {
      return <MenuItem value={item.locale} primaryText={item.name} key={`${item.locale}item-${item.name}${i}`} />
    })
  }

  handleDelete = () =>{
    this.setState({
      isDialogVisible: true
    })
  }

  handleCloseDialog = () => {
    this.setState({
      isDialogVisible: false
    })
  }


  render() {
    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleCloseDialog}
      />,
      <FlatButton
        label="Delete"
        primary={true}
        keyboardFocused={true}
        onClick={() => this.props.onDelete(this.props.id)}
      />,
    ];
    return(
      <div>
        <div className="product-options-translations">
          <div className="product-options-translations__remove-btn-container">
            <i 
              onClick={this.handleDelete}
              className="fa fa-minus-square"
            />
          </div>
          <div>
            <Field 
              component={renderSelectField}
              name={`language${this.props.translationNumber}`}
              type="dropdown"
              placeholder=""
              label="Language"
            >
              { this.renderItems(this.props.languages) }
            </Field>
          </div>
          <Field
            component={renderTextField}
            name={`languageText${this.props.translationNumber}`}
            type="text"
            label="Value"
          />
        </div>
        <Dialog
          title="Delete Item"
          actions={actions}
          modal={false}
          open={this.state.isDialogVisible}
          onRequestClose={this.handleClose}
        >
          Are you sure to delete this item.
        </Dialog>
      </div>
    )
 }
}

TranslationFields.proptTypes = {
  items: PropTypes.array
}

export default TranslationFields;


// WEBPACK FOOTER //
// ./src/components/productoption/translationFields/TranslationFields.js